import React from "react"
import { Paper, TextField } from "@material-ui/core"
import Autocomplete from "@material-ui/lab/Autocomplete"
import { useTranslation } from "react-i18next"
import type { ReporterMembershipOption } from "../hooks/use-reported-hours-membership-options"

const ReporterMembershipFilter = ({
  memberships,
  selectedMembershipId,
  isLoading,
  onChange,
}: ReporterMembershipFilterProps) => {
  const { t } = useTranslation("hour-report")
  const sortedMemberships = React.useMemo(
    () => [...memberships].sort((first, second) => first.fullname.localeCompare(second.fullname)),
    [memberships]
  )
  const selectedMembership = memberships.find((membership) => membership.id === selectedMembershipId) ?? null

  return (
    <Paper variant="outlined" elevation={0} style={{ minWidth: 280, padding: 16, marginBottom: 16 }}>
      <Autocomplete
        options={sortedMemberships}
        value={selectedMembership}
        loading={isLoading}
        getOptionLabel={(option) => option.fullname}
        getOptionSelected={(option, value) => option.id === value.id}
        onChange={(_, membership) => onChange(membership?.id ?? null)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={t("reporterFilter.chooseMember", { defaultValue: "Choose member" })}
            placeholder={t("reporterFilter.allMembers", { defaultValue: "All members" })}
            variant="outlined"
            size="small"
          />
        )}
      />
    </Paper>
  )
}

type ReporterMembershipFilterProps = {
  memberships: ReporterMembershipOption[]
  selectedMembershipId: string | null
  isLoading: boolean
  onChange: (membershipId: string | null) => void
}

export default ReporterMembershipFilter
